import {getSelectedVendorFromStorage} from 'utils/Helper';

export const getCampaignVendorId = (): number => {
  const vendorId = getSelectedVendorFromStorage()?.id;
  const parsed = Number(vendorId);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatCampaignDate = (dateString?: string): string => {
  if (!dateString) {
    return '';
  }

  return new Date(dateString).toLocaleDateString('fa-IR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
